import React from 'react';
import * as S from './ProfileMenuIcon.styles';
import { useAuthStore } from '@/store/useAuthStore';
import { ProfileDefaultIcon } from '@/components/UI/Icons/Icons';

export const ProfileMenuIcon = () => {
  const { shop, features } = useAuthStore(state => state.userInfo);
  const hasLogo = features?.servicesFeatures?.hasLogo;
  const shopLogoUrl = shop?.logo?.url;
  const showShopLogo = Boolean(shopLogoUrl) && hasLogo !== false;

  return (
    <S.ProfileMenuIconBox data-testid="profile-menu-icon">
      {showShopLogo ? (
        <img
          alt=""
          src={shopLogoUrl}
          width={34}
          height={34}
          style={{ objectFit: 'contain', borderRadius: '50%' }}
          loading="lazy"
        />
      ) : (
        <ProfileDefaultIcon />
      )}
    </S.ProfileMenuIconBox>
  );
};
